import DetailsPanelService from '@/utilities/bid/cost/DetailsPanelService'
import SummaryTotals from '@/utilities/bid/cost/SummaryTotals'
import SummaryTable from '@/utilities/bid/cost/SummaryTable'
import SummaryClientTable from '@/utilities/bid/cost/SummaryClientTable'
import VanTable from '@/utilities/bid/cost/VanTable'
import Totals from '@/utilities/bid/cost/Totals'
import Api from '@/api'

const api = new Api()

export default {
  async fetchCostings({ commit }, payload) {
    try {
      const resp = await api
        .sales()
        .bid()
        .costings()
        .fetch(payload)

      const response = resp.data.data
      commit('setCostings', response.costings ? response.costings : [])
      commit('setConstants', response.constants ? response.constants : [])

      const detailsPanelService = new DetailsPanelService(response.costings.detailed, response.constants.workCode)
      const calculatedDetailed = detailsPanelService.getAll()
      commit('setCalculatedDetailed', calculatedDetailed)

      const summaryTotals = new SummaryTotals(calculatedDetailed)
      const sTotalsAll = summaryTotals.getAll()
      commit('setTotals', sTotalsAll)

      const summaryTable = new SummaryTable(calculatedDetailed, sTotalsAll)
      const mainSummary = summaryTable.getAll()

      const totals = new Totals(mainSummary)
      const van = new VanTable(calculatedDetailed.labour, response.costings.main.shift, response.costings.main.total)
      commit('setMain', {
        summary: mainSummary,
        shift: response.costings.main.shift ? response.costings.main.shift : [],
        van: van.getAll(),
        total: totals.getAll(),
      })

      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err?.response?.data?.errors ?? err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async submitCostings({ commit, rootState }) {
    try {
      const payload = rootState.Bid.Cost.calculated
      const bidNumber = rootState.Bid.bidNumber

      const table = new SummaryClientTable(rootState.Bid.summary)
      payload.main.specification = table.specification(bidNumber)

      const resp = await api
        .sales()
        .bid()
        .costings()
        .submit(bidNumber, payload)

      const response = resp.data.data
      commit('Dashboard/setFeedback', response, { root: true })

      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err?.response?.data?.errors ?? err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
